var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPilotLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2348 11.7975H23.7598V9.3225C23.7598 5.313 20.5095 2.0625 16.4998 2.0625C12.4902 2.0625 9.23984 5.31283 9.23984 9.3225V11.7975H6.76484C4.94225 11.7975 3.46484 13.2749 3.46484 15.0975V27.6375C3.46484 29.4601 4.94225 30.9375 6.76484 30.9375H26.2348C28.0574 30.9375 29.5348 29.4601 29.5348 27.6375V15.0975C29.5348 13.2749 28.0574 11.7975 26.2348 11.7975ZM11.5498 9.3225C11.5498 6.59307 13.7704 4.3725 16.4998 4.3725C19.2293 4.3725 21.4498 6.59307 21.4498 9.3225V11.7975H11.5498V9.3225ZM27.2248 27.6375C27.2248 28.1833 26.7808 28.6275 26.2348 28.6275H6.76484C6.21886 28.6275 5.77484 28.1833 5.77484 27.6375V15.0975C5.77484 14.5517 6.21886 14.1075 6.76484 14.1075H26.2348C26.7808 14.1075 27.2248 14.5517 27.2248 15.0975V27.6375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 17.7373C16.1944 17.7373 15.9006 17.859 15.684 18.0756C15.4674 18.2922 15.3457 18.586 15.3457 18.8923V24.5023C15.3457 24.654 15.3756 24.8042 15.4336 24.9443C15.4917 25.0844 15.5767 25.2118 15.684 25.319C15.7912 25.4263 15.9186 25.5113 16.0587 25.5694C16.1988 25.6274 16.349 25.6573 16.5007 25.6573C16.6524 25.6573 16.8026 25.6274 16.9427 25.5694C17.0828 25.5113 17.2102 25.4263 17.3174 25.319C17.4247 25.2118 17.5097 25.0844 17.5678 24.9443C17.6258 24.8042 17.6557 24.654 17.6557 24.5023V18.8923C17.6557 18.586 17.534 18.2922 17.3174 18.0756C17.1008 17.859 16.807 17.7373 16.5007 17.7373Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotLock);
export default __webpack_public_path__ + "static/media/pilot-lock.e1014b759949623da57da833c313d8ba.svg";
export { ForwardRef as ReactComponent };